import React from 'react'
import { connect } from 'react-redux'
import DSLoadingIndicator from '@elliemae/ds-basic/dsloadingindicator'

const ScreenLoader = ({ opts }) => {
  return (
        <DSLoadingIndicator
            loading={opts.show}
            message='Loading, please wait...'
            style={{ color: 'white', fontSize: '1.5em' }}
        />
  )
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const mapStateToProps = (state, meta) => {
  return {
    opts: state.screenLoader,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenLoader)



// WEBPACK FOOTER //
// ./main/src/components/ScreenLoader.js